/* eslint-disable import/prefer-default-export */
import { useShopConfig } from './shopConfig';

export const useTax = () => {
  const { internationalConfig } = useShopConfig();
  const { stripeTaxCode } = internationalConfig;
  return { stripeTaxCode, isTaxEnabled: !!stripeTaxCode };
};
